import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import { Link } from 'gatsby';
import styled, { css } from 'styled-components';

const confettiShapeYellowHexagon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAzMCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5Ljc4NjEgMjMuNDE2NEwyNS44OTE1IDYuMDgzMDFMMTcuMjcxNiAwLjU3MTU3TC0wLjAwMDQwNDAzIDQuMzcxMDZMMy43OTg1MyAyMS42NDMxTDEyLjQxODQgMjcuMTU0NkwyOS43ODYxIDIzLjQxNjRaIiBmaWxsPSIjRkZERjZFIi8+Cjwvc3ZnPgo=';
const confettiShapeBlueTriangle = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyMSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjU2MzMgMjMuNDEyNkwyLjIwNzg1IDIuMDc2MjhMMTkuNTE5MiA2LjAxMTQ4TDE1LjU2MzMgMjMuNDEyNloiIHN0cm9rZT0iIzFDQUJCRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=';
const confettiShapeOrangeTriangle = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAyNSAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjY1ODEgMi42MjExNkwyMi40Mjc1IDMxLjQ4NTRMMi4xNDEwNiAyMy4wMTI1TDEwLjY1ODEgMi42MjExNloiIHN0cm9rZT0iI0ZGNzA2MiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=';
const confettiShapePlumRhombus = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAzMSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMzc1MDU4IDAuMTUyMzE1TDMwLjYxNTEgMTIuNDUzNUwyOC4wODI1IDI0LjY3NDJMMTkuNDc3NCAyOC45Njg0TDAuMzc1MDU4IDAuMTUyMzE1WiIgZmlsbD0iIzk2MzQ4MSIvPgo8L3N2Zz4K';
const confettiShapeBlueHexagon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAzMCAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjIzNDYgMS41MjM5MUwxLjE3ODMgNC41ODE2Nkw0LjM4MDQ1IDIwLjYwOThMMTIuMTgxNiAyNS44NjM3TDI4LjE1MTIgMjIuNzQ3NUwyNS4wMzU3IDYuNzc3ODZMMTcuMjM0NiAxLjUyMzkxWiIgc3Ryb2tlPSIjMUNBQkJGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==';
const confettiShapeSalmonRhombus = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCA0NSAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQzLjkyNDYgOS4xMjgwM0w5LjE4ODY4IDEuODEwOTlMMS4wODEwOCAxNi4zMzhMNS42Njc5NyAyNi40NjA5TDQzLjkyNDYgOS4xMjgwM1oiIHN0cm9rZT0iI0ZGNzA2MiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=';

const articleGroupCss = [
  css`
    background:
    url(${confettiShapeYellowHexagon}) 87% 1.6% / 15px auto no-repeat,
    url(${confettiShapeBlueTriangle}) 5% 1.8% / 13px auto no-repeat,
    url(${confettiShapeOrangeTriangle}) 97% 2.8% / 13px auto no-repeat;

    @media screen and (min-width: ${layout.subLg}) {
      background:
        url(${confettiShapeBlueTriangle}) 12% 5% / 23px auto no-repeat,
        url(${confettiShapeYellowHexagon}) 91% 4% / 23px auto no-repeat,
        url(${confettiShapeOrangeTriangle}) 84% 7% / 20px auto no-repeat;
    }
  `,
  css`
    @media screen and (min-width: ${layout.subLg}) {
      background: url(${confettiShapePlumRhombus}) 84% 7% / 25px auto no-repeat;
    }
  `,
  css`
    @media screen and (min-width: ${layout.subLg}) {
      background: url(${confettiShapeBlueHexagon}) 8% 7% / 22px auto no-repeat;
    }
  `,
  css`
    @media screen and (min-width: ${layout.subLg}) {
      background: url(${confettiShapeSalmonRhombus}) 84% 7% / 28px auto no-repeat;
    }
  `
]

interface ArticleGroupWrapperProps {
  index?: number
}

// This important on line 50 is required to overwrite default layout width
export const ArticleGroupWrapper = styled.div<ArticleGroupWrapperProps>`
  max-width: 100vw !important;
  ${({ index }) => index >= 0 ? articleGroupCss[index] : ''}
`

export const ArticleGroupContainer = styled.div`
  display: grid;
  row-gap: 1rem;
  padding: 2rem 2rem;
  margin-bottom: 3rem !important;
  margin-left: auto;
  margin-right: auto;
  max-width: 1229px !important;
`

export const ArticleGroup = styled.div`
  display: grid;
  column-gap: 2rem;
  margin: 2rem 0rem 2rem;;
  grid-template-columns: 1fr 1fr 1fr;

  & > a {
    text-decoration: none;
    color: ${palette.text};
    display: grid;
  }

  @media all and (max-width: ${layout.subMd}) {
    grid-template-columns: 1fr;
    row-gap: 2rem;
  }
`

export const Article = styled(Link)`
  height: 100%;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  color: ${palette.text};
  display: grid;
  background: ${palette.white};
  box-shadow: 0px 0px 0.922676px rgba(0, 0, 0, 0.05), 0px 0.922676px 18.4535px rgba(0, 0, 0, 0.15);
  grid-template-rows: 1fr 245px;
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: 0 2px 25px 0 rgb(0 0 0 / 0.3);

    > div {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media all and (max-width: ${layout.subLg}) {
    grid-template-rows: 1fr 205px;
  }
`

export const ArticlePreviewDescription = styled.div`
  background: linear-gradient(180deg, transparent 0,rgba(0,0,0,.4) 30%,rgba(0,0,0,.6));
  font-size: 1.25rem;
  line-height: 1.4;
  display: flex;
  font-weight: 400;
  box-sizing: border-box;
  padding: 1.8rem;
  color: ${palette.white};
  align-items: flex-end;
  text-align: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 35%;
  z-index: 1;
  opacity: 0;
  transform: translateY(100%);
  transition: all .3s ease-out;

  @media all and (max-width: ${layout.subLg}) {
    display: none;
  }
`

export const ArticleTitle = styled.div`
  box-sizing: border-box;
  padding: 16px 20px 24px;
  align-self: center;
`

export const ArticleImage = styled.div`
  height: 245px;
  align-self: end;
  max-height: 100%;

  & > div {
    height: 100%;
  }
`

export const ArticleLinkContainer = styled.div`
  justify-self: center;
  a {
    border: 1.2px solid ${palette.sierraRain};
    box-sizing: border-box;
    border-radius: 6px;
    font-size: 1em;
    font-weight: 500;
    padding: .8rem 8.45rem;
    color: ${palette.sierraRain};
    width: 330px;
    text-decoration: none;

    @media all and (max-width: ${layout.subLg}) {
      padding: .6rem 6rem;
    }

    @media all and (max-width: ${layout.xs}) {
      padding: .6rem 5rem;
    }
  }
`
